import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m38.897 31.115 2.546 2.91A3 3 0 0 1 39.185 39H8a3 3 0 0 1-2.258-4.975l2.529-2.89a5 5 0 0 0 1.233-3.48l-.397-10.618c-.006-.168-.01-.337-.01-.505C9.098 9.058 15.158 3 22.63 3h1.726c.134 0 .269.002.403.006 7.522.223 13.44 6.501 13.218 14.024l-.315 10.644a5 5 0 0 0 1.235 3.44ZM18.096 41.408a1 1 0 1 1 1.831-.803 4 4 0 0 0 7.326.012 1 1 0 1 1 1.828.81 6 6 0 0 1-10.985-.019ZM12.475 29h22.243c1.333 0 1.333 2 0 2H12.475c-1.333 0-1.333-2 0-2Z",
      clipRule: "evenodd"
    }
  )
);
var SvgNotificationOnFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var NotificationOnFilled_default = SvgNotificationOnFilled;

export { NotificationOnFilled_default as default };
